import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../../../../../shared/user.service';
import { ContractService } from '../../../../../shared/contract.service';


@Component({
  selector: 'app-contract-supporting-documents',
  templateUrl: './contract-supporting-documents.component.html',
  styleUrls: ['./contract-supporting-documents.component.scss']
})

export class ContractSupportingDocumentsComponent implements OnInit, AfterViewInit {
  @Input() contractId;
  @Input() mode;
  @Input() isContractEditPermission;
  supportingDocSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  files: NgxFileDropEntry[] = [];
  supportingDocColumns: string[] = ['Document Name', 'Uploaded By', 'Uploaded On', 'Action']
  dataLoading: boolean = false;
  downloadLoading: { [key: string]: boolean } = {};

  constructor(public contractService: ContractService, public userService: UserService, private toast: ToastrService) { }

  ngOnInit() {
    if (this.contractId) {
      this.getSupportingDocuments();
    }
  }

  ngAfterViewInit(): void {
    this.supportingDocSource.paginator = this.paginator;
    this.supportingDocSource.sort = this.sort
  }

  async getSupportingDocuments() {
    this.dataLoading = true;
    try {
      await this.contractService.getAllDocuments(this.contractId).then((res: any) => {
        res.forEach((doc: any) => {
          doc.createdDate = moment(doc.createdDate).format('lll');
        });
        this.supportingDocSource.data = res;
      })
    } catch (error) {
      this.toast.error('Something went wrong! Please try again later.', '');
    }
    this.dataLoading = false;
  }


  async dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    this.dataLoading = true;
    this.supportingDocSource.data = null;
    const uploadPromises: Promise<void>[] = [];
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        const fileUploadedPromise = new Promise<void>((resolve, reject) => {
          fileEntry.file((file: File) => {
            try {
              this.contractService.uploadSupportingDocument(droppedFile.relativePath, file, this.contractId)
                .then(() => {
                  this.toast.success('The document(s) have been uploaded successfully!', '');
                  resolve();
                })
                .catch((error) => {
                  this.toast.error('Something went wrong! Please try again later.', '');
                  reject(error);
                });
            } catch (error) {
              this.toast.error('Something went wrong! Please try again later.', '');
              reject(error);
            }
          });
        });

        uploadPromises.push(fileUploadedPromise);
      } else {
        this.toast.error('Something went wrong! Please try again later.', '');
      }
    }

    try {
      await Promise.all(uploadPromises);
      this.getSupportingDocuments();
    } catch (error) {
      console.error('Error occurred during file upload:', error);
    }
  }

  downloadSupportingDocument(id: number) {
    this.downloadLoading[id] = true;

    this.contractService.downloadSuportingDocument(id);
    setTimeout(() => {
      this.downloadLoading[id] = false;
      this.toast.success('Document Downloaded Sucessfully!', '');
    }, 2000);
  }


  customSortData(event: Sort) {
    const data = this.supportingDocSource.data.slice();
    if (!event.active || event.direction === '') {
      this.supportingDocSource.data = data;
      return;
    }

    this.supportingDocSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || '').toString().toLowerCase();
      const valueB = (b[event.active] || '').toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === 'asc');
    });

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
